import { useTranslation } from 'next-i18next';

import { Button, Typography } from '@/shared/components/atoms';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import ArrowUp from '~/images/shared/ArrowUp.svg';
import Chart from '~/images/shared/Chart.svg';
import Unlock from '~/images/shared/Unlock.svg';

const UpgradePlanModal: React.FC<{ variant: string; onClick?: () => void }> = ({
  variant,
  onClick,
}) => {
  const { t } = useTranslation();

  const { closeModal } = useModal();

  return (
    <div className=' max-w-[392px]'>
      <div className='flex flex-col items-center justify-center gap-24'>
        <span>
          <Unlock width='48' height='48' />
        </span>
        <div className='flex flex-col gap-8 border-b-xs border-neutralVariant-90 pb-24 text-center'>
          <Typography variant='h2' weight='semiBold'>
            {variant}
          </Typography>
          <Typography className='text-surface-10'>
            {t('Premium Feature')}
          </Typography>
          <Typography className='text-surface-10'>
            {t(
              'You can access this feature by upgrading your plan. Available for Business plan and above.'
            )}
          </Typography>
        </div>
        <div className='grid w-full grid-cols-3 items-end gap-16'>
          <div className='col-span-2'>
            <Typography weight='semiBold' variant='h3'>
              {t('Business Plan')}
            </Typography>
            <Typography className='mt-4 mb-16 text-surface-10'>
              {t(
                'Enhanced efficiency and control through Advanced Field Intelligence.'
              )}
            </Typography>
            <div className='flex items-center gap-8'>
              <div className='flex items-center gap-4'>
                <span className='text-secondary-20'>
                  <ArrowUp width='20' height='20' />
                </span>
                <Typography
                  className='text-green-300'
                  weight='semiBold'
                  variant='subtitle2'
                >
                  100%
                </Typography>
              </div>
              <Typography
                variant='subtitle2'
                weight='semiBold'
                className='text-surface-10'
              >
                {t('more efficiency')}
              </Typography>
            </div>
          </div>
          <div className='col-span-1'>
            <Chart width='128' height='64' />
          </div>
        </div>
      </div>
      <Button
        className='mt-32 h-56 w-full rounded-xl'
        size='none'
        onClick={() => {
          onClick ? onClick() : closeModal();
        }}
      >
        {t('Dismiss')}
      </Button>
    </div>
  );
};

export { UpgradePlanModal };
